import { CommandAction } from 'src/app/abstract/command/command-action.service';
import { WidgetsInputModel } from 'src/app/models/widgets/widgets-input.model';
import { WidgetsAbstract } from '../../abstract/widgets/widgets.abstract';
import { Injectable } from '@angular/core';
import { WidgetsService } from '../widgets/widgets.service';
import { Logger } from 'src/app/core/logger';
import { WidgetsSelectionService } from '../widgets/widgets-selection.service';

@Injectable()
export class CommandInputService extends CommandAction {
  constructor(
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private logger: Logger
  ) {
    super();
  }

  public execute(
    parent: WidgetsAbstract,
    widget: WidgetsAbstract
  ): WidgetsInputModel {
    const newWidget = new WidgetsInputModel();
    newWidget.parentId = parent.id;
    newWidget.type = 'input';
    newWidget.key = this.widgetsService.getNextKey(newWidget.type);

    // A new Primitive borns selected
    this.selectionService.select(newWidget);
    return newWidget;
  }
}
